<template>
  <div class="main">
    <div class="steps clearfix text-center">
      <Logo :biz="!this.formData.isPrivateClient ? 'corp':'priv'" />
    </div>
    <div class="container">
      <h2>Setup your online access</h2>
      <p class="text-center">
        Do you need any help?&nbsp;<a
          href=""
          data-target="#helpModal"
          data-toggle="modal"
          >Get in touch
        </a>
      </p>
      <div class="signup-form wizard clearfix pt-0">
        <div class="steps clearfix text-center">
          <img src="/assets/img/icons8-lock-100.png" />
        </div>
        <div class="content clearfix">
          <div class="row">
            <!-- <div class="col-sm-12">
                <h4 class="info-text ">
                  Let's get started
                </h4>
              </div> -->
            <two-fa
              v-if="showTwoFa"
              :token="token"
              @verifiedTwoFa="verifiedTwoFa($event)"
            />
            <template v-else>
           

              <form id="form-password" class="p-t-15" autocomplete="off" @submit.prevent="signup()">
                <h3>Security questions</h3>
                <div class="col-sm-12">
                  <div class="alert alert-info" role="alert">
                    Please set your security questions/answers to continue.
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="form-label required"
                      >Security Question #1:</label
                    >
                    <select
                      id="ddlFirstQuestion"
                      name="ddlFirstQuestion"
                      :class="{ error: errors.has('step1.ddlFirstQuestion') }"
                      data-vv-scope="step1"
                      v-validate="'required'"
                      class="form-control custom-select"
                      v-model="firstQuestionSelected"
                      required
                    >
                      <option value="" selected="selected">Please select...</option>
                      <option
                        v-for="(question, index) in getfirstAllQuestions"
                        class=""
                        :key="index"
                        :value="question.CodesId"
                      >
                        {{ question.SelectionValue }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="form-label required">Answer #1:</label>
                    <input
                      type="text"
                      id="firstanswer"
                      name="firstanswer"
                      class="form-control"
                      :class="{ error: errors.has('step1.firstanswer') }"
                      data-vv-scope="step1"
                      v-validate="'required'"
                      required
                      v-model.trim="firstAnswer"
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="form-label required"
                      >Security Question #2:</label
                    >
                    <select
                      id="ddlSecondQuestion"
                      name="ddlSecondQuestion"
                      :class="{ error: errors.has('step1.ddlSecondQuestion') }"
                      data-vv-scope="step1"
                      v-validate="'required'"
                      class="form-control custom-select"
                      v-model="secondQuestionSelected"
                      required
                    >
                      <option value="" selected="selected">Please select...</option>
                      <option
                        v-for="(question, index) in getsecondAllQuestions"
                        :key="index"
                        class=""
                        :value="question.CodesId"
                      >
                        {{ question.SelectionValue }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="form-label required">Answer #2:</label>
                    <input
                      type="text"
                      id="secondanswer"
                      name="secondanswer"
                      class="form-control"
                      :class="{ error: errors.has('step1.secondanswer') }"
                      data-vv-scope="step1"
                      v-validate="'required'"
                      required
                      v-model.trim="secondAnswer"
                    />
                  </div>
                </div>
                <hr />
                <h3>Enter your new password</h3>
                <div class="col-sm-12">
                  <div class="alert alert-info" role="alert">
                    <strong>Note: </strong>Password must contain at least 8
                    characters, including UPPER/lowercase and numbers and at
                    least a special character (!@#$%^&amp;*).
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="form-label required">Password</label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      class="form-control"
                      :class="{ error: errors.has('step1.password') }"
                      data-vv-scope="step1"
                      v-validate="'required|min:8|verify_password'"
                      ref="password"
                      required
                      v-model="password"
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="form-label required">Confirm Password</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      class="form-control"
                      :class="{ error: errors.has('step1.confirmPassword') }"
                      data-vv-scope="step1"
                      data-vv-as="password"
                      v-validate="'required|confirmed:password'"
                      required
                      v-model="confirmPassword"
                    />
                  </div>
                </div>
                <div class="col-sm-12 mt-2">
                  <div class="form-group mt-3">
                    <input
                      type="checkbox"
                      id="terms"
                      name="terms"
                      class=""
                      required
                      v-model="isTermsAccepted"
                    />&nbsp;
                    <label for="terms" class="terms">
                      I have read and agree to the &nbsp;
                      <a
                        :href="tandc"
                        target="_blank"
                        >Terms and Conditions</a
                      >.
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <message-info />
                </div>
                <div class="col-sm-12 mt-3">
                  <input
                    type="button"
                    class="btn btn-fill btn-success btn-block btn-wd btn-md"
                    name="save"
                    value="complete"
                    @click.prevent="signup()"
                  />
                </div>
              </form>
            </template>

            <div class="col-sm-12 mt-2">
              <hr />
              <privacy-policy />
            </div>
          </div>
        </div>
        <Loading v-if="loading" />
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "@/components/ui/Logo.vue";
import mixin from "@/components/shared/mixinUtility";
import TwoFa from "@/components/verification/VerifyCodeFTL.vue";
import axios from "axios";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import Loading from "@/components/ui/Loading.vue";
import VeeValidate from "vee-validate";
import {mapGetters} from "vuex";
import PrivacyPolicy from '@/components/ui/PrivacyPolicy.vue';

VeeValidate.Validator.extend("verify_password", {
  // eslint-disable-next-line
  getMessage: (field) =>
    "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)",
  validate: (value) => {
    // eslint-disable-next-line
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return strongRegex.test(value);
  },
});
export default {
  name: "FirstTimeLogin",
  mixins: [mixin],
  rules: {
    custom: {
      verify_password: true,
    },
  },
  data() {
    return {
      showTwoFa: false,
      token: "",
      loading: false,
      firstQuestionSelected: "",
      secondQuestionSelected: "",
      firstAnswer: "",
      secondAnswer: "",
      password: "",
      confirmPassword: "",
      isTermsAccepted: false,
      allQuestions: [],
    };
  },
  created() {
    if (this.$route.params.tokenvalue) {
      this.token = this.$route.params.tokenvalue;
      if (this.token != "") {
        //show 2fa first
        this.showTwoFa = true;
        this.getSecurityQuestions();
      }
    }
  },
  computed: {
    ...mapGetters({
      formData: "getFormData",
    }),
    getfirstAllQuestions() {
      return this.allQuestions.filter(
        (question) => question.CodesId !== this.secondQuestionSelected
      );
    },
    getsecondAllQuestions() {
      return this.allQuestions.filter(
        (question) => question.CodesId !== this.firstQuestionSelected
      );
    },
    tandc(){
      return (this.formData.isPrivateClient) ? process.env.VUE_APP_TC_PRIVATE : process.env.VUE_APP_TC_CORPORATE;
    }
  },
  methods: {
    async signup() {
      this.resetMessageInfo();
      this.$root.$validator.validate("step1.*").then(async (valid) => {
        if (valid) {
          try {
            if (this.isTermsAccepted) {
              this.loading = true;
              let formData = {
                Password: this.password,
                FirstQuestionId: parseInt(this.firstQuestionSelected),
                SecondQuestionId: parseInt(this.secondQuestionSelected),
                FirstAnswer: this.firstAnswer,
                SecondAnswer: this.secondAnswer,
              };
                    console.log(this.password)
              await axios.post(
                process.env.VUE_APP_SMT_API_URL + "/Client/CreateOnlineUser",
                formData,
                {
                  headers: {
                    token: this.token,
                    "Access-Control-Allow-Origin": "*",
                  },
                }
              );
              this.loading = false;
              //show success page
              this.$router.push({ name: "Success" });
            } else {
              this.showGenericErrorMessage(
                "Please accept terms and conditions.",
                false
              );
            }
            //test
          } catch (ex) {
            this.showGenericErrorMessage("We've encountered a problem.", false);
            this.loading = false;
          }
          //all valid?
        } else {
          //not valid
          this.showGenericErrorMessage(
            "Please enter all mandatory fields.",
            false
          );
        }
      });
    },
    verifiedTwoFa(token) {
      //reset token
      this.showTwoFa = false;
      this.token = token;
    },
    getSecurityQuestions() {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/client/GetBudgetAndTimeScale?selectionName=securityQuest"
        )
        .then((res) => {
          this.allQuestions = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  components: {
    Logo,
    Loading,
    "two-fa": TwoFa,
    MessageInfo,
      "privacy-policy": PrivacyPolicy,
  },
};
</script>
